import { FILE_BASE_URL } from "../../../apiConfig";
import { Play } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";
import defaultPoster from "../../../images/featured.png";

function FeaturedVidCard({ data, onClick }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <motion.div 
            onClick={() => onClick && onClick(data)}
            onHoverStart={() => setIsHovered(true)}
            onHoverEnd={() => setIsHovered(false)}
            whileHover={{ y: -5 }}
            style={{
                width: '100%',
                height: '220px', // Slightly taller for more presence
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '8px',
                background: '#000', // Solid black base
                cursor: 'pointer',
                border: isHovered 
                    ? '1.5px solid rgba(255,255,255,0.3)' 
                    : '1px solid rgba(255,255,255,0.05)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
        >
            {/* Background Image Layer */}
            <motion.div
                animate={{ scale: isHovered ? 1.08 : 1 }}
                transition={{ duration: 0.6, ease: [0.33, 1, 0.68, 1] }}
                style={{
                    position: 'absolute',
                    inset: 0,
                    background: `url("${defaultPoster}") center/cover no-repeat`,
                    opacity: 0.7
                }}
            />

            {/* Video Preview element */}
            <motion.video
                animate={{ 
                    scale: isHovered ? 1.08 : 1,
                    opacity: isHovered ? 0.6 : 0.4
                }}
                transition={{ duration: 0.6, ease: [0.33, 1, 0.68, 1] }}
                style={{
                    position: 'absolute',
                    top: 0, left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                }}
                muted
                loop
                autoPlay
                preload="none"
                playsInline
                poster={defaultPoster}
            >
                <source src={`${FILE_BASE_URL}/${data.vedio}`} type="video/mp4" />
            </motion.video>

            {/* HD / Video Badge */}
            <div style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                padding: '4px 10px',
                background: 'rgba(0,0,0,0.4)',
                backdropFilter: 'blur(8px)',
                borderRadius: '4px',
                border: '1px solid rgba(255,255,255,0.1)',
                zIndex: 2,
            }}>
                <span style={{ 
                    fontFamily: 'var(--fontDisplay)', 
                    fontSize: '10px', 
                    fontWeight: 700, 
                    color: '#fff',
                    letterSpacing: '1px'
                }}>HD VIDEO</span>
            </div>

            {/* Play Button Overlay */}
            <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1,
            }}>
                <motion.div
                    animate={{ 
                        scale: isHovered ? 1.1 : 0.9,
                        opacity: isHovered ? 1 : 0.9,
                    }}
                    transition={{ duration: 0.2 }}
                    style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        background: 'rgba(255, 255, 255, 0.15)',
                        backdropFilter: 'blur(10px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1.5px solid rgba(255,255,255,0.4)',
                        boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                    }}
                >
                    <Play size={24} color="#fff" fill="#fff" />
                </motion.div>
            </div>

            {/* Glassmorphism Title Bar */}
            <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '20px 16px',
                background: isHovered ? 'transparent' : 'linear-gradient(transparent, rgba(0,0,0,0.9))',
                transition: 'background 0.4s ease',
                zIndex: 2,
            }}>
                <p style={{
                    fontFamily: 'var(--fontDisplay)', // Barlow Condensed
                    fontSize: '18px',
                    fontWeight: 700,
                    lineHeight: '1.2',
                    color: '#fff',
                    margin: 0,
                    overflow: 'visible',
                    textShadow: '0 2px 4px rgba(0,0,0,0.8)',
                    transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
                    transition: 'transform 0.3s ease',
                }}>
                    {data.title}
                </p>
                <div style={{ 
                    width: isHovered ? '40px' : '0px', 
                    height: '2px', 
                    background: '#E7C424', 
                    marginTop: '8px',
                    transition: 'width 0.3s ease',
                }} />
            </div>
        </motion.div>
    );
}

export default FeaturedVidCard;
